export class Agency {
    public Name: string;
    public Email: string;
    public DispatchEmail: string;
    public PartnerCode: string;
    public Address: string;
    public ZipCode: string;
    public City: string;
    public Phone: string;

    static mapFromJSON(json) {
        const a = new Agency();

        a.Name = json['name'];
        a.Email = json['email'];
        a.DispatchEmail = json['dispatchEmail'];
        a.PartnerCode = json['partnerCode'];
        a.Address = json['address'];
        a.ZipCode = json['zipCode'];
        a.City = json['city'];
        a.Phone = json['phone'];

        return a;
    }
}